/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { PlaquePersonneMoraleDto } from '../models/plaque-personne-morale-dto';


/**
 * Fonctions de gestion des plaques d'une personne morale
 */
@Injectable({
  providedIn: 'root',
})
export class PlaquesPersonneMoraleService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation plaquesPersonneMoraleGetList
   */
  static readonly PlaquesPersonneMoraleGetListPath = '/api/plaques-personne-morale/list/{personneMoraleId}';

  /**
   * Renvoie la liste des plaques d'une personne morale spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquesPersonneMoraleGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquesPersonneMoraleGetList$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;
  }): Observable<StrictHttpResponse<Array<PlaquePersonneMoraleDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesPersonneMoraleService.PlaquesPersonneMoraleGetListPath, 'get');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PlaquePersonneMoraleDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des plaques d'une personne morale spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquesPersonneMoraleGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquesPersonneMoraleGetList(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;
  }): Observable<Array<PlaquePersonneMoraleDto>> {

    return this.plaquesPersonneMoraleGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PlaquePersonneMoraleDto>>) => r.body as Array<PlaquePersonneMoraleDto>)
    );
  }

  /**
   * Path part for operation plaquesPersonneMoraleLoadList
   */
  static readonly PlaquesPersonneMoraleLoadListPath = '/api/plaques-personne-morale/load-list/{personneMoraleId}';

  /**
   * Renvoie la liste des plaques de la personne morale spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquesPersonneMoraleLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquesPersonneMoraleLoadList$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesPersonneMoraleService.PlaquesPersonneMoraleLoadListPath, 'post');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des plaques de la personne morale spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquesPersonneMoraleLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquesPersonneMoraleLoadList(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.plaquesPersonneMoraleLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation plaquesPersonneMoraleGet
   */
  static readonly PlaquesPersonneMoraleGetPath = '/api/plaques-personne-morale/{id}';

  /**
   * Renvoie la plaque spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquesPersonneMoraleGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquesPersonneMoraleGet$Response(params: {

    /**
     * Identifiant de la plaque
     */
    id: number;
  }): Observable<StrictHttpResponse<PlaquePersonneMoraleDto>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesPersonneMoraleService.PlaquesPersonneMoraleGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlaquePersonneMoraleDto>;
      })
    );
  }

  /**
   * Renvoie la plaque spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquesPersonneMoraleGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquesPersonneMoraleGet(params: {

    /**
     * Identifiant de la plaque
     */
    id: number;
  }): Observable<PlaquePersonneMoraleDto> {

    return this.plaquesPersonneMoraleGet$Response(params).pipe(
      map((r: StrictHttpResponse<PlaquePersonneMoraleDto>) => r.body as PlaquePersonneMoraleDto)
    );
  }

  /**
   * Path part for operation plaquesPersonneMoralePut
   */
  static readonly PlaquesPersonneMoralePutPath = '/api/plaques-personne-morale/{id}';

  /**
   * Met à jour la plaque spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquesPersonneMoralePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquesPersonneMoralePut$Response(params: {

    /**
     * Identifiant de la plaque à mettre à jour
     */
    id: number;

    /**
     * Plaque
     */
    body: PlaquePersonneMoraleDto
  }): Observable<StrictHttpResponse<PlaquePersonneMoraleDto>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesPersonneMoraleService.PlaquesPersonneMoralePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlaquePersonneMoraleDto>;
      })
    );
  }

  /**
   * Met à jour la plaque spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquesPersonneMoralePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquesPersonneMoralePut(params: {

    /**
     * Identifiant de la plaque à mettre à jour
     */
    id: number;

    /**
     * Plaque
     */
    body: PlaquePersonneMoraleDto
  }): Observable<PlaquePersonneMoraleDto> {

    return this.plaquesPersonneMoralePut$Response(params).pipe(
      map((r: StrictHttpResponse<PlaquePersonneMoraleDto>) => r.body as PlaquePersonneMoraleDto)
    );
  }

  /**
   * Path part for operation plaquesPersonneMoraleDelete
   */
  static readonly PlaquesPersonneMoraleDeletePath = '/api/plaques-personne-morale/{id}';

  /**
   * Supprime la plaque spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquesPersonneMoraleDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquesPersonneMoraleDelete$Response(params: {

    /**
     * Identifiant de la plaque à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesPersonneMoraleService.PlaquesPersonneMoraleDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la plaque spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquesPersonneMoraleDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  plaquesPersonneMoraleDelete(params: {

    /**
     * Identifiant de la plaque à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.plaquesPersonneMoraleDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation plaquesPersonneMoralePost
   */
  static readonly PlaquesPersonneMoralePostPath = '/api/plaques-personne-morale/{personneMoraleId}';

  /**
   * Crée la plaque spécifiée pour une personne morale spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `plaquesPersonneMoralePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquesPersonneMoralePost$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Plaque
     */
    body: PlaquePersonneMoraleDto
  }): Observable<StrictHttpResponse<PlaquePersonneMoraleDto>> {

    const rb = new RequestBuilder(this.rootUrl, PlaquesPersonneMoraleService.PlaquesPersonneMoralePostPath, 'post');
    if (params) {
      rb.path('personneMoraleId', params.personneMoraleId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PlaquePersonneMoraleDto>;
      })
    );
  }

  /**
   * Crée la plaque spécifiée pour une personne morale spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `plaquesPersonneMoralePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  plaquesPersonneMoralePost(params: {

    /**
     * Identifiant de la personne morale
     */
    personneMoraleId: number;

    /**
     * Plaque
     */
    body: PlaquePersonneMoraleDto
  }): Observable<PlaquePersonneMoraleDto> {

    return this.plaquesPersonneMoralePost$Response(params).pipe(
      map((r: StrictHttpResponse<PlaquePersonneMoraleDto>) => r.body as PlaquePersonneMoraleDto)
    );
  }

}
